import { render, staticRenderFns } from "./GraficoDonutEnergy.vue?vue&type=template&id=e8582244&"
import script from "./GraficoDonutEnergy.vue?vue&type=script&lang=js&"
export * from "./GraficoDonutEnergy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports